import React from 'react';
import { HomeIcon, ClipboardListIcon, BarChart3Icon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface BottomNavProps {
  activeTab: 'home' | 'checklists' | 'reports';
  onTabChange: (tab: 'home' | 'checklists' | 'reports') => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const {
    colors
  } = useTheme();
  const tabs = [{
    id: 'home' as const,
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'checklists' as const,
    label: 'Checklists',
    icon: ClipboardListIcon
  }, {
    id: 'reports' as const,
    label: 'Reports',
    icon: BarChart3Icon
  }];
  return <nav className="fixed bottom-0 left-0 right-0 border-t" style={{
    backgroundColor: colors.cardSurface,
    borderColor: colors.divider
  }} data-id="element-41">
      <div className="flex items-center justify-around h-16" data-id="element-42">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="flex flex-col items-center justify-center flex-1 h-full min-w-[48px] transition-colors" style={{
          color: isActive ? colors.accent : colors.textPrimary,
          opacity: isActive ? 1 : 0.6
        }} aria-label={tab.label} aria-current={isActive ? 'page' : undefined} data-id="element-43">
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} data-id="element-44" />
              <span className="text-xs mt-1 font-medium" data-id="element-45">{tab.label}</span>
            </button>;
      })}
      </div>
    </nav>;
}